<template>
  <div class="col-md-12" style="padding: 10px;">
    <div class="card card-map" id="card-content">
      <div class="card-header">
        <div class="row">
          <div class="col-md-1">
            <button class="btn" @click="backClick()">Volver</button>
          </div>
          <div class="col-md-2">
            <h5
              class="card-title"
              align="right"
              style="color: black; font-weight: bolder;"
            >Intervalo:</h5>
          </div>
          <div class="col-md-9">
            <el-slider
              class="slider-success"
              style="padding-right: 20px;"
              range
              v-model="slideBack"
              :show-tooltip="false"
              show-stops
              @change="changeRange"
              :marks="marks"
              :step="1"
              :min="0"
              :max="48"
            ></el-slider>
          </div>
        </div>
      </div>
      <div class="card-body">

        <div id="historyMapId">
          <!-- <p-progress :value="progressValue" type="info"></p-progress> -->
          <GmapMap
            :center="center"
            :options="mapOptions"
            style="width: 100%; height: 100%"
            ref="histMapRef"
          >
            <GmapPolyline
              v-show="pointsInRange.length > 0"
              :path="pointsInRange"
              :options="pathOptions"
              :editable="false"
              ref="polyline"
            ></GmapPolyline>
          </GmapMap>
        </div>

        <div class="row footer-row">
          <div class="row-fluid chartLabel">
            <stats-card
              type="info"
              class="stats"
              :title="infoCard.mainText1"
              :small-title="infoCard.littleText1"
              :title2="infoCard.mainText2"
              :small-title2="infoCard.littleText2"
              :title3="infoCard.mainText3"
              :small-title3="infoCard.littleText3"
              icon="nc-icon nc-alert-circle-i"
            ></stats-card>
          </div>
          <div class="row-fluid chartLabel">
            <stats-card
              type="info"
              class="stats"
              :title="routeCard.mainText1"
              :small-title="routeCard.littleText1"
              :title2="routeCard.mainText2"
              :small-title2="routeCard.littleText2"
              :title3="routeCard.mainText3"
              :small-title3="routeCard.littleText3"
              icon="nc-icon nc-sound-wave"
            ></stats-card>
          </div>
          <div class="row-fluid chartLabel">
            <stats-card
              type="info"
              class="stats"
              :title="timeCard.mainText1"
              :small-title="timeCard.littleText1"
              :title2="timeCard.mainText2"
              :small-title2="timeCard.littleText2"
              :title3="timeCard.mainText3"
              :small-title3="timeCard.littleText3"
              icon="nc-icon nc-watch-time"
            ></stats-card>
          </div>
          <!-- <div class="row-fluid chartLabel">
                <stats-card type="info"
                :title="stateCard.mainText1" :small-title="stateCard.littleText1"
                :title2="stateCard.mainText2" :small-title2="stateCard.littleText2"
                :title3="stateCard.mainText3" :small-title3="stateCard.littleText3"
                icon="nc-icon nc-settings">
              </stats-card>
          </div>-->
          <!-- <div>
              <div class="row-fluid chartArea">
                <highcharts id="speedChart" ref="high" :options="chartOptions"></highcharts>
              </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { Slider } from "element-ui";
import { mapState } from "vuex";
import ReporteService from "../../../services/reporte";
import { Card, StatsCard } from "src/components/UIComponents";
import GmapMap from "vue2-google-maps/dist/components/map";
import GmapPolyline from "vue2-google-maps/dist/components/polyline";
import PProgress from "src/components/UIComponents/Progress.vue";
import { gmapApi } from "vue2-google-maps";

export default {
  components: {
    [Slider.name]: Slider,
    Card,
    StatsCard,
    GmapMap,
    GmapPolyline,
    PProgress
  },
  computed: {
    ...mapState(["historicoMapa"]),
    google: gmapApi
  },
  data() {
    return {
      historicMapObj: {},
      center: { lat: -33.748817, lng: -60.985428 },
      pointsInRange: [],
      carPath: [],
      firstPath: false,
      slideBack: [0, 48],
      pathOptions: {
        geodesic: false,
        strokeColor: "#005ec0",
        strokeOpacity: 0.8,
        strokeWeight: 6
      },
      mapOptions: {
        zoom: 8,
        scrollwheel: true,
        mapTypeId: "terrain",
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: true,
        rotateControl: true,
        fullscreenControl: true,
        disableDefaultUi: false,
        mapTypeControlOptions: {
          style: "",
          position: ""
        }
      },
      marks: {
        0: { label: "0:00", value: "00:00:01" },
        1: { label: "", value: "00:30:00" },
        2: { label: "", value: "01:00:00" },
        3: { label: "", value: "01:30:00" },
        4: { label: "2:00", value: "02:00:00" },
        5: { label: "", value: "02:30:00" },
        6: { label: "", value: "03:00:00" },
        7: { label: "", value: "03:30:00" },
        8: { label: "4:00", value: "04:00:00" },
        9: { label: "", value: "04:30:00" },
        10: { label: "", value: "05:00:00" },
        11: { label: "", value: "05:30:00" },
        12: { label: "6:00", value: "06:00:00" },
        13: { label: "", value: "06:30:00" },
        14: { label: "", value: "07:00:00" },
        15: { label: "", value: "07:30:00" },
        16: { label: "8:00", value: "08:00:00" },
        17: { label: "", value: "08:30:00" },
        18: { label: "", value: "09:00:00" },
        19: { label: "", value: "09:30:00" },
        20: { label: "10:00", value: "10:00:00" },
        21: { label: "", value: "10:30:00" },
        22: { label: "", value: "11:00:00" },
        23: { label: "", value: "11:30:00" },
        24: { label: "12:00", value: "12:00:00" },
        25: { label: "", value: "12:30:00" },
        26: { label: "", value: "13:00:00" },
        27: { label: "", value: "13:30:00" },
        28: { label: "14:00", value: "14:00:00" },
        29: { label: "", value: "14:30:00" },
        30: { label: "", value: "15:00:00" },
        31: { label: "", value: "15:30:00" },
        32: { label: "16:00", value: "16:00:00" },
        33: { label: "", value: "16:30:00" },
        34: { label: "", value: "17:00:00" },
        35: { label: "", value: "17:30:00" },
        36: { label: "18:00", value: "18:00:00" },
        37: { label: "", value: "18:30:00" },
        38: { label: "", value: "19:00:00" },
        39: { label: "", value: "19:30:00" },
        40: { label: "20:00", value: "20:00:00" },
        41: { label: "", value: "20:30:00" },
        42: { label: "", value: "21:00:00" },
        43: { label: "", value: "21:30:00" },
        44: { label: "22:00", value: "22:00:00" },
        45: { label: "", value: "22:30:00" },
        46: { label: "", value: "23:00:00" },
        47: { label: "", value: "23:30:00" },
        48: { label: "24:00", value: "23:59:00" }
      },
      gpsPoints: [],
      objetoReporte: {},
      infoCard: {
        littleText1: "Vehículo",
        mainText1: "",
        littleText2: "Fecha",
        mainText2: "",
        littleText3: "",
        mainText3: ""
      },
      routeCard: {
        littleText1: "Distancia",
        mainText1: "",
        littleText2: "Vel. Max.",
        mainText2: "",
        littleText3: "",
        mainText3: ""
      },
      timeCard: {
        littleText1: "Tiempo Parado",
        mainText1: "",
        littleText2: "Tiempo en Viaje",
        mainText2: "",
        littleText3: "",
        mainText3: ""
      }
    };
  },
  methods: {
    mapInitialize() {
      this.mapOptions.mapTypeControlOptions.style = this.google.maps.MapTypeControlStyle.HORIZONTAL_BAR;
      this.mapOptions.mapTypeControlOptions.position = this.google.maps.ControlPosition.TOP_RIGHT;
    },
    changeRange() {
      let year = new Date(this.gpsPoints[0].ts).getFullYear();
      let month = new Date(this.gpsPoints[0].ts).getMonth();
      month = month + 1;
      let day = new Date(this.gpsPoints[0].ts).getDate();

      var fechaConsultaIni = new Date(
        year +
          "-" +
          month +
          "-" +
          day +
          " " +
          this.marks[this.slideBack[0]].value
      );
      var fechaConsultaEnd = new Date(
        year +
          "-" +
          month +
          "-" +
          day +
          " " +
          this.marks[this.slideBack[1]].value
      );
      this.pointsInRange = [];

      for (let i = 0; i < this.gpsPoints.length; i++) {
        let fechaTemp = new Date(this.gpsPoints[i].ts);

        if (fechaTemp >= fechaConsultaIni && fechaTemp <= fechaConsultaEnd) {
          this.pointsInRange.push(this.gpsPoints[i]);
        }
      }
      this.setPolyline();
    },
    setPolyline() {
      var mapBounds = new this.google.maps.LatLngBounds();
      var self=this
      this.pointsInRange.forEach(function(value, key, array) {
        mapBounds.extend(new self.google.maps.LatLng(value.lat, value.lng));
      });
      this.historicMapObj.fitBounds(mapBounds);
    },
    handleResize() {
      let navbarHeight = document.getElementById("navbar").offsetHeight;
      let windowHeight = window.innerHeight;
      let contentHeight = windowHeight - navbarHeight;
      let mapHeight = contentHeight - 280;
      document.getElementById("historyMapId").style.height = mapHeight + "px";
    },
    backClick() {
      this.$router.go(-1);
    },
    mapLoadError(error) {
      alert("No se pudo inicializar el mapa:", error);
    },
    getHistoricPoints() {
        ReporteService.historicoMapa(
        this.historicoMapa.veh_id,
        this.historicoMapa.log_rep_date
        ).then(res => {
        this.gpsPoints = res.data;

        for (let j = 0; j < this.gpsPoints.length; j++) {
            var obj = this.gpsPoints[j];
            obj.lng = obj.lon;
            delete obj.lon;
        }
        this.changeRange();
        });
    }
  },
  created() {
    this.infoCard.mainText1 = this.historicoMapa.veh_id;
    this.infoCard.mainText2 = this.historicoMapa.log_rep_date;
    this.routeCard.mainText1 =
      (this.historicoMapa.log_rep_distance / 1000).toFixed(1) + " Km";
    this.routeCard.mainText2 = this.historicoMapa.log_rep_max_speed + "Km/h";
    this.timeCard.mainText1 = this.historicoMapa.log_rep_stop_time;
    this.timeCard.mainText2 = this.historicoMapa.log_rep_trip_time;
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    this.$refs.histMapRef.$mapPromise
      .then(mapObj => {
        this.historicMapObj = mapObj;
        this.mapInitialize();
        this.getHistoricPoints();
      })
      .catch(error => this.mapLoadError(error));

  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>
<style scoped>

.row-fluid {
  content: "";
  clear: both;
  display: table;
  line-height: 130%;
}
.footer-row {
  height: 150px;
}
.chartLabel .stats {
  color: black;
}

.chartLabel {
  position: relative;
  width: 33.33%;
  padding: 15px;
  float: left;
  margin-top: 0;
}

#card-content {
  color: #d6d2c8;
  min-width: 240px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 1);
}

.card {
  color: #d6d2c8;
  min-width: 240px;
  box-shadow: 0px 6px 10px 1px rgba(0, 0, 0, 0.5);
}
</style>
